import { Attribute, Directive, Input, OnInit, Optional } from '@angular/core';
import { DestroyedService } from 'app/shared/destroyed/destroyed.service';
import { takeUntil } from 'rxjs/operators';
import { CxUiComponentService } from '../cx-component.service';
import { CxUiConfigService } from '../cx-ui.config.service';
import { CxUiInputTimeFormat, CxUiInputTimeControlButtons, CxUiInputTimeHideResetButton, CxUiInputTimeLabelApply, CxUiInputTimeLabelCancel } from './cx-input-time.config';
import { CwcInputTime } from '@cmx-web-components/angular';
import { combineLatest } from 'rxjs';

@Directive({
  /* tslint:disable */
  selector: 'cwc-input-time',
  providers: [DestroyedService, CxUiComponentService],
})
export class CxInputTimeProviderDirective implements OnInit {
  constructor(
    private cxUiComponent: CxUiComponentService<CwcInputTime>,
    private cxUiConfig: CxUiConfigService,

    private destroyed: DestroyedService,

    @Optional() @Attribute('format') private timeFormatAttribute?: CxUiInputTimeFormat,
    @Optional() @Attribute('control-buttons') private controlButtonsAttribute?: CxUiInputTimeControlButtons,
    @Optional() @Attribute('hide-reset-button') private hideResetButtonAttribute?: CxUiInputTimeHideResetButton,
    @Optional() @Attribute('label-apply') private labelApplyAttribute?: CxUiInputTimeLabelApply,
    @Optional() @Attribute('label-cancel') private labelCancelAttribute?: CxUiInputTimeLabelApply,
  ) {
    // eslint-disable-next-line max-len
    this.cxUiComponent.hasSomeAttributeOf([timeFormatAttribute, controlButtonsAttribute, hideResetButtonAttribute, labelApplyAttribute, labelCancelAttribute]);
  }

  @Input()
  public format?: CxUiInputTimeFormat;

  @Input()
  public controlButtons?: CxUiInputTimeControlButtons;

  @Input()
  public hideResetButton?: CxUiInputTimeHideResetButton;

  @Input()
  public labelApply?: CxUiInputTimeLabelApply;

  @Input()
  public labelCancel?: CxUiInputTimeLabelCancel;

  public ngOnInit() {
    combineLatest([
      this.cxUiConfig.selectValueOf('timeFormat'),
      this.cxUiConfig.selectValueOf('timeControlButtons'),
      this.cxUiConfig.selectValueOf('timeHideResetButton'),
      this.cxUiConfig.selectValueOf('timeLabelApply'),
      this.cxUiConfig.selectValueOf('timeLabelCancel'),
    ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(([timeFormat, timeControlButtons, timeHideResetButton, timeLabelApply, timeLabelCancel]) => {
        if (this.format === undefined) {
          this.cxUiComponent.setProperty('format', this.timeFormatAttribute || timeFormat);
        }
        if (this.controlButtons === undefined) {
          this.cxUiComponent.setProperty('controlButtons', this.controlButtonsAttribute || timeControlButtons);
        }
        if (this.hideResetButton === undefined) {
          this.cxUiComponent.setProperty('hideResetButton', this.hideResetButtonAttribute || timeHideResetButton);
        }
        if (this.labelApply === undefined) {
          this.cxUiComponent.setProperty('labelApply', this.labelApplyAttribute || timeLabelApply);
        }
        if (this.labelCancel === undefined) {
          this.cxUiComponent.setProperty('labelCancel', this.labelCancelAttribute || timeLabelCancel);
        }
      });
  }
}
